import { api } from './client';
import type { Company, Membership, Invite, Paginated } from '@/types';

export const companiesApi = {
  async list(): Promise<Paginated<Company>> {
    const { data } = await api.get<Paginated<Company>>('/companies/');
    return data;
  },
  async get(id: number): Promise<Company> {
    const { data } = await api.get<Company>(`/companies/${id}/`);
    return data;
  },
  async update(id: number, payload: Partial<Company>): Promise<Company> {
    const { data } = await api.patch<Company>(`/companies/${id}/`, payload);
    return data;
  },
};

export const membersApi = {
  async list(): Promise<Paginated<Membership>> {
    const { data } = await api.get<Paginated<Membership>>('/members/');
    return data;
  },
  async changeRole(id: number, role: string): Promise<Membership> {
    const { data } = await api.post<Membership>(`/members/${id}/change_role/`, { role });
    return data;
  },
  async deactivate(id: number): Promise<void> { await api.post(`/members/${id}/deactivate/`); },
};

export const invitesApi = {
  async list(): Promise<Paginated<Invite>> {
    const { data } = await api.get<Paginated<Invite>>('/invites/');
    return data;
  },
  async create(email: string, role: string): Promise<Invite> {
    const { data } = await api.post<Invite>('/invites/', { email, role });
    return data;
  },
  async revoke(id: number): Promise<void> { await api.post(`/invites/${id}/revoke/`); },
  async resend(id: number): Promise<void> { await api.post(`/invites/${id}/resend/`); },
};
